import React from "react";
import { Droppable } from "react-beautiful-dnd";
import DraggableItem from "./DraggableItem";

import { StyledPlaceholderDiv, StyledStack } from "./styles";
import { Stack } from "@mui/material";

const DroppableWrapper = ({
  droppableId,
  column,
  elements = [],
  includeSnapshot,
  placeholderProps,
  disablePlaceholder,
  Component,
  customDroppableProps = {},
  direction = "vertical",
  StartComponent,
}) => {
  return (
    <Stack className="HubDroppable-stack" gap="10px">
      {StartComponent && <StartComponent column={column} />}
      <Droppable droppableId={String(droppableId)} direction={direction}>
        {(provided, snapshot) => (
          <StyledStack
            className="HubDroppable-root"
            ref={provided.innerRef}
            {...provided.droppableProps}
            {...customDroppableProps}
          >
            {elements?.map((element, idx) => (
              <DraggableItem
                key={element.id}
                element={element}
                order={idx}
                includeSnapshot={includeSnapshot}
                Component={Component}
              />
            ))}
            {provided.placeholder}
            {!disablePlaceholder && (
              <div
                className="HubDroppable-placeholder"
                style={StyledPlaceholderDiv({
                  placeholderProps,
                  disabled:
                    placeholderProps?.destinationId !== String(droppableId),
                })}
              />
            )}
          </StyledStack>
        )}
      </Droppable>
    </Stack>
  );
};

export default DroppableWrapper;
